type NamedConfig = {
  id: string;
  spec_name?: string;
  name?: string;
};

export function getConfigNameById(
  configs: NamedConfig[] | null | undefined,
  configId: string | null | undefined,
): string {
  if (!configId || !configs?.length) {
    return '';
  }
  const match = configs.find((config) => config.id === configId);
  return match?.spec_name ?? match?.name ?? '';
}
